import { useTranslation } from 'react-i18next';

export default function PlayCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="rounded-2xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Dynamic%20anime%20style%20action%20scene%20with%20two%20characters%20clashing%20in%20epic%20battle%2C%20dramatic%20lighting%20with%20golden%20and%20coral%20energy%20effects%2C%20warm%20cinematic%20atmosphere%2C%20film%20grain%20texture%2C%20clean%20composition%2C%20high%20quality%20anime%20art%2C%20excitement%20and%20intensity&width=1400&height=600&seq=cta-anime-play&orientation=landscape"
            alt="立即播放动漫"
            title="立即播放 - 樱花动漫"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <div className="text-center">
          <p className="text-xl md:text-3xl font-heading text-foreground-900 leading-relaxed mb-2">
            <em className="text-foreground-500 not-italic font-light">{t('手机专为看动漫而生')}</em>
          </p>
          <p className="text-xl md:text-3xl font-heading text-foreground-900 font-bold leading-relaxed mb-6">
            {t('开始追番')}
          </p>
          <button className="inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap">
            <i className="ri-play-circle-fill text-lg"></i>
            {t('立即播放')}
          </button>
        </div>
      </div>
    </section>
  );
}